export const apiTagsMethods = {
  async getTags() {
    return this.request('/api/tags.php', { _skipGlobalErrorModal: true });
  },

  async createTag(name, color = '#2196F3', textColor = '#ffffff') {
    return this.request('/api/tags.php', {
      method: 'POST',
      body: JSON.stringify({ name, color, text_color: textColor }),
    });
  },

  async updateTag(id, name, color, textColor) {
    return this.request('/api/tags.php', {
      method: 'PUT',
      body: JSON.stringify({ id, name, color, text_color: textColor }),
    });
  },

  async deleteTag(id) {
    return this.request('/api/tags.php', {
      method: 'DELETE',
      body: JSON.stringify({ id }),
    });
  },

  async assignTag(tagId, contactoUserId) {
    return this.request('/api/tags.php?action=assign', {
      method: 'POST',
      body: JSON.stringify({ tag_id: tagId, contacto_user_id: contactoUserId }),
      _skipGlobalErrorModal: true,
    });
  },

  async unassignTag(tagId, contactoUserId) {
    return this.request('/api/tags.php?action=unassign', {
      method: 'POST',
      body: JSON.stringify({ tag_id: tagId, contacto_user_id: contactoUserId }),
      _skipGlobalErrorModal: true,
    });
  },

  async getContactTags(contactoUserId) {
    return this.request(`/api/tags.php?action=contact_tags&contacto_user_id=${contactoUserId}`, {
      _skipGlobalErrorModal: true,
    });
  },
};
